import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { experiences } from '../constants';

const Experience = () => {
  return (
    <section className="min-h-screen w-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white scroll-mt-24" id="experience">
      <div className="mx-auto max-w-5xl px-4 pt-28 reveal-on-scroll">
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-sky-400/80">
          Experience
        </p>
        <h2 className="mt-2 text-3xl font-extrabold sm:text-4xl md:text-5xl">
          <span className="bg-gradient-to-r from-sky-300 via-teal-300 to-emerald-300 bg-clip-text text-transparent">
            Work & Programs
          </span>
        </h2>
        <p className="mt-3 max-w-2xl text-sm sm:text-base text-slate-300">
          A snapshot of virtual experience programs and roles that helped me
          sharpen my software engineering skills and understand real-world workflows.
        </p>
      </div>
      <div className="mx-auto mt-10 max-w-5xl px-2 pb-16">
        <VerticalTimeline>
          {experiences.map((experience) => (
            <VerticalTimelineElement
              key={`${experience.company}-${experience.duration}`}
              className="vertical-timeline-element--work"
              contentStyle={{
                background: 'linear-gradient(135deg, #020617, #020617, #0f172a)',
                color: '#e5e7eb',
                borderRadius: '1rem',
                boxShadow: '0 18px 45px rgba(15,23,42,0.9)',
                border: '1px solid rgba(148,163,184,0.35)'
              }}
              contentArrowStyle={{ borderRight: '7px solid #020617' }}
              date={experience.duration}
              iconStyle={{ background: '#020617', boxShadow: '0 0 0 4px #0ea5e9' }}
              icon={
                <a
                  className="flex h-full w-full items-center justify-center"
                  href={experience.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={experience.logo}
                    alt={experience.company}
                    className="h-[60%] w-[60%] object-contain"
                  />
                </a>
              }
            >
              <div>
                <h3 className="text-lg font-semibold text-slate-50 sm:text-xl">
                  {experience.role}
                </h3>
                <p className="mt-1 text-sm font-medium text-sky-300">
                  {experience.company}
                </p>
              </div>
              <ul className="mt-4 ml-4 space-y-2 text-sm text-slate-200">
                {experience.points.map((point, index) => (
                  <li key={`experience-point-${index}`} className="list-disc leading-relaxed">
                    {point}
                  </li>
                ))}
              </ul>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
};

export default Experience;